import { render, staticRenderFns } from "./VScroller.vue?vue&type=template&id=71599634&scoped=true&"
import script from "./VScroller.vue?vue&type=script&lang=ts&"
export * from "./VScroller.vue?vue&type=script&lang=ts&"
import style0 from "./VScroller.vue?vue&type=style&index=0&id=71599634&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71599634",
  null
  
)

export default component.exports